export const EvenIcon = () => (
    <svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
        <rect fill="#ff6a13" height="32" rx="16" width="32" />
        <path d="m10.75 16h10.5" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </svg>
);
